import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import React from "react";
import { PrimarySidebarHeader } from "../../Layout/PrimarySidebarLayout";
import { AcademicPlanStatusIDs } from "../../../Domain/AcademicPlanStatus/AcademicPlanStatus.model";
import FAIcon from "../../UI/FAIcon/FAIcon";
const SideBarItems = {
    ALL: "all",
    REQUIRES_ADVISOR_FEEDBACK: "requiresAdvisorFeedback",
    AWAITING_STUDENT_RESPONSE: "awaitingStudentResponse",
    APPROVED: "approved",
    OFF_PLAN: "offPlan",
};
const PlansSidebar = (props) => {
    const doSearch = (criteria) => {
        if (props.onSearch) {
            props.onSearch(criteria);
        }
    };
    const onRequiresAdvisorFeedbackClick = () => {
        doSearch({
            academicPlanStatusIds: [AcademicPlanStatusIDs.PENDING_ADVISOR],
            // @ts-expect-error - TS2322 - Type 'null' is not assignable to type 'boolean'.
            isOffPlan: null,
        });
    };
    const onAwaitingStudentResponseClick = () => {
        doSearch({
            academicPlanStatusIds: [AcademicPlanStatusIDs.PENDING_STUDENT],
            // @ts-expect-error - TS2322 - Type 'null' is not assignable to type 'boolean'.
            isOffPlan: null,
        });
    };
    const onApprovedClick = () => {
        doSearch({
            academicPlanStatusIds: [AcademicPlanStatusIDs.APPROVED],
            // @ts-expect-error - TS2322 - Type 'null' is not assignable to type 'boolean'.
            isOffPlan: null,
        });
    };
    const onOffPlanClick = () => {
        // @ts-expect-error - TS2345 - Argument of type '{ academicPlanStatusIds: never[]; isOffPlan: true; }' is not assignable to parameter of type 'AcademicPlanSearch'.
        doSearch({
            academicPlanStatusIds: [],
            isOffPlan: true,
        });
    };
    const onAllClick = () => {
        // @ts-expect-error - TS2322 - Type 'null' is not assignable to type 'boolean'.
        doSearch({ academicPlanStatusIds: [], isOffPlan: null });
    };
    const sidebarItems = [
        {
            sidebarItemId: SideBarItems.ALL,
            clickHandler: onAllClick,
            faIcon: "asterisk",
            title: "All Plans",
            showCount: false,
            count: 0,
        },
        {
            sidebarItemId: SideBarItems.REQUIRES_ADVISOR_FEEDBACK,
            clickHandler: onRequiresAdvisorFeedbackClick,
            faIcon: "comments-alt",
            title: "Pending Advisor",
            showCount: true,
            count: props.counts.requiresAdvisorFeedback,
        },
        {
            sidebarItemId: SideBarItems.AWAITING_STUDENT_RESPONSE,
            clickHandler: onAwaitingStudentResponseClick,
            faIcon: "hourglass",
            title: "Pending Student",
            showCount: true,
            count: props.counts.awaitingStudentResponse,
        },
        {
            sidebarItemId: SideBarItems.APPROVED,
            clickHandler: onApprovedClick,
            faIcon: "check",
            title: "Approved",
            showCount: true,
            count: props.counts.approved,
        },
        {
            sidebarItemId: SideBarItems.OFF_PLAN,
            clickHandler: onOffPlanClick,
            faIcon: "exclamation-circle",
            title: "Off Plan",
            showCount: false,
            count: 0,
        },
    ];
    let selectedSidebarItem = SideBarItems.ALL;
    // see if the criteria from the parent matches the search criteria for one of the nav items and select that, if so.
    // otherwise, leave it on the 'all' status.
    if (props.criteria.isOffPlan == null &&
        props.criteria.academicPlanStatusIds.length === 1 &&
        props.criteria.academicPlanStatusIds[0] ===
            AcademicPlanStatusIDs.PENDING_ADVISOR) {
        // @ts-expect-error - TS2322 - Type '"requiresAdvisorFeedback"' is not assignable to type '"all"'.
        selectedSidebarItem = SideBarItems.REQUIRES_ADVISOR_FEEDBACK;
    }
    if (props.criteria.isOffPlan == null &&
        props.criteria.academicPlanStatusIds.length === 1 &&
        props.criteria.academicPlanStatusIds[0] ===
            AcademicPlanStatusIDs.PENDING_STUDENT) {
        // @ts-expect-error - TS2322 - Type '"awaitingStudentResponse"' is not assignable to type '"all"'.
        selectedSidebarItem = SideBarItems.AWAITING_STUDENT_RESPONSE;
    }
    if (props.criteria.isOffPlan === null &&
        props.criteria.academicPlanStatusIds.length === 1 &&
        props.criteria.academicPlanStatusIds[0] === AcademicPlanStatusIDs.APPROVED) {
        // @ts-expect-error - TS2322 - Type '"approved"' is not assignable to type '"all"'.
        selectedSidebarItem = SideBarItems.APPROVED;
    }
    if (props.criteria.isOffPlan === true &&
        props.criteria.academicPlanStatusIds.length === 0) {
        // @ts-expect-error - TS2322 - Type '"offPlan"' is not assignable to type '"all"'.
        selectedSidebarItem = SideBarItems.OFF_PLAN;
    }
    //   console.log("PlansSidebar pre-render", {
    //     props,
    //     selectedSidebarItem,
    //     SideBarItems,
    //   });
    return (_jsxs(_Fragment, { children: [_jsx(PrimarySidebarHeader, { title: "Statuses", setIsOpen: props.setIsOpen }), sidebarItems.map((item) => (_jsx("div", { className: `p-sidebar-item ${selectedSidebarItem === item.sidebarItemId ? "active" : ""}`, children: _jsxs("div", { className: "p-sidebar-item-title", tabIndex: 0, onKeyPress: item.clickHandler, onClick: item.clickHandler, role: "button", children: [_jsx(FAIcon, { icon: item.faIcon, title: item.title, fixedWidth: true }), _jsxs("span", { className: "p-sidebar-hide-on-close ml-1", children: [item.title, " ", item.showCount ? `(${item.count})` : ""] })] }) }, item.title)))] }));
};
export default PlansSidebar;
